const SetupRef = () => {
    return (
        <div id="bot-scene-container" className="">
            <div id="bot-scene-content" className="scroll-light">
                <div className="app-v2-header-wrapper has-subtitle has-extra">
                    <div className="app-v2-header-left">
                        <span className="app-v2-header-title">
                            Đường dẫn Ref</span>
                        <span className="app-v2-header-subtitle">
                            Điều hướng khách hàng vào các kịch bản khác nhau với đường dẫn dạng.
                            <a href="" target="_blank">
                                Tìm hiểu thêm
                            </a>
                        </span>
                    </div>
                    <div className="app-v2-header-extra-wrapper">
                        <button className="btn btn-primary p-sm-l p-sm-r app-v2-gtm-auto-keyword-new ml15">
                            <span>
                                + Thêm từ khóa mới
                            </span>
                        </button>
                    </div>
                </div>



                {/* ------------------------------- */}
                <div className="app-v2-layout-content">
                    <div >
                        <div className="hrs-filter-container-master">
                            <div className="hrs-filter-container">
                                <div className="hrs-filter-wrapper">
                                    <div className="hrs-btn-open-filter">
                                        <div className="svg-next-icon icon-filter">
                                        </div>
                                        <span>Bộ lọc tìm kiếm</span>
                                    </div>
                                </div>
                                <div className="hrs-filter-search-wrapper">
                                    <svg width="16" height="16" viewBox="0 0 16 16">
                                        <path fill="#8993A4" fillRule="evenodd"
                                            d="M6.8 13.6a6.8 6.8 0 115.34-2.59l3.626 3.624a.8.8 0 01-1.132 1.132L11.01 12.14A6.77 6.77 0 016.8 13.6zm3.728-3.175a.817.817 0 00-.103.103 5.2 5.2 0 11.102-.102z"
                                            clipRule="evenodd"></path>
                                    </svg >
                                    <input className="hrs-filter-input-search" placeholder="Tìm kiếm" value="" />
                                </div>
                            </div>
                        </div>

                        <div className="app-table-container ref-parameters--container app-scrollbar app-scrollbar-visible">
                            <table className="app-table app-table--vertical-middle">
                                <thead>
                                    <tr>
                                        <th className="text-left-i" style={{ width: "100px" }}>Kích hoạt</th>
                                        <th className="text-left-i">Tên kịch bản</th>
                                        <th className="text-left-i" style={{ width: "130px" }}>Đã đọc</th>
                                        <th className="text-left-i" style={{ width: "130px" }}>Đã click</th>
                                        <th className="text-center-i" style={{ width: "130px" }}>Hành động</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="ref-parameters--item--wrapper">
                                        <td>
                                            <div className="input-switch input-switch-on keyboard-input-ctrl"><label>
                                                <div className="input-checkbox text-center checked">
                                                    <div className="svg-next-icon icon-check ic-check">
                                                    </div>
                                                    <div className="svg-next-icon ic-box">
                                                    </div>
                                                </div><i></i>
                                            </label></div>
                                        </td>

                                        <td>ref_copy_10098</td>
                                        <td>0</td>
                                        <td>0
                                            (0%)
                                        </td>
                                        <td>
                                            <div className="ref-actions-wrapper1">
                                                <div>
                                                    <a className="text-hide-gray hover-color-blue-line-through p-t5 p-b5 p-l5 p-r5 ml3 mr3 pointer">
                                                        <i>
                                                            <svg ariaHidden="true" focusable="false" dataprefix="far" dataicon="edit" className="svg-inline--fa fa-edit fa-w-18 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                                                <path fill="currentColor" d="M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z">
                                                                </path>
                                                            </svg>
                                                        </i>
                                                    </a>
                                                </div>
                                                <div>
                                                    <a className="text-hide-gray hover-color-blue-line-through p-t5 p-b5 p-l5 p-r5 ml3 mr3 pointer">
                                                        <i>
                                                            <svg ariaHidden="true" focusable="false" dataprefix="far" dataicon="clone" className="svg-inline--fa fa-clone fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                                <path fill="currentColor" d="M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z">
                                                                </path>
                                                            </svg>
                                                        </i>
                                                    </a>
                                                </div>
                                                <div>
                                                    <a className="text-hide-gray hover-color-blue-line-through p-t5 p-b5 p-l5 p-r5 ml3 mr3 pointer">
                                                        <i>
                                                            <svg ariaHidden="true" focusable="false"
                                                                dataprefix="fas" dataicon="external-link-alt"
                                                                className="svg-inline--fa fa-external-link-alt fa-w-18 " role="img"
                                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                                                <path fill="currentColor"
                                                                    d="M576 24v127.984c0 21.461-25.96 31.98-40.971 16.971l-35.707-35.709-243.523 243.523c-9.373 9.373-24.568 9.373-33.941 0l-22.627-22.627c-9.373-9.373-9.373-24.569 0-33.941L442.756 76.676l-35.703-35.705C391.982 25.9 402.656 0 424.024 0H552c13.255 0 24 10.745 24 24zM407.029 270.794l-16 16A23.999 23.999 0 0 0 384 303.765V448H64V128h264a24.003 24.003 0 0 0 16.97-7.029l16-16C376.089 89.851 365.381 64 344 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V287.764c0-21.382-25.852-32.09-40.971-16.97z">
                                                                </path>
                                                            </svg>
                                                        </i>
                                                    </a>
                                                </div>
                                            </div>
                                            {/* <div style="position: absolute; top: 0px; left: 0px; width: 100%;">
                                                <div>
                                                    <div className="app-tooltip  app-tooltip-placement-top  app-tooltip-hidden" style="left: 1435px; top: 50px; transform-origin: 50% -4px;">
                                                        <div className="app-tooltip-content">
                                                            <div className="app-tooltip-arrow">
                                                            </div>
                                                            <div className="app-tooltip-inner" role="tooltip">Sao chép</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="position: absolute; top: 0px; left: 0px; width: 100%;">
                                                <div>
                                                    <div className="app-tooltip  app-tooltip-placement-top  app-tooltip-hidden" style="left: 1401px;top: 50px; transform-origin: 50% -4px;">
                                                        <div className="app-tooltip-content">
                                                            <div className="app-tooltip-arrow">
                                                            </div>
                                                            <div className="app-tooltip-inner" role="tooltip">Chỉnh sửa</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="table-wrapper">
                            <div className="app-report-table--pagination">
                                <div className="app-pagination ">
                                    <div className="app-pagination--options">
                                        <div className="app-pagination-dropdown">
                                            <div className="app-pagination-dropdown--text">Hiển thị</div>
                                            <div className="app-pagination-dropdown--btn">
                                                <div className="app-pagination-dropdown--number">20</div>
                                                <div className="app-pagination-dropdown--icon">
                                                    <svg className="app-svg-inline-block app-svg-next-icon-rotate-90" width="16px"
                                                        height="16px" viewBox="0 0 16 16">
                                                        <path d="M6.47 4L5.53 4.94L8.58333 8L5.53 11.06L6.47 12L10.47 8L6.47 4Z">
                                                        </path>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ul className="app-pagination--listpage">
                                        <li className="app-pagination-total-text">Đang hiển thị 1-1 /  6 </li>
                                        <li className="app-pagination--item app-pagination--item-active">
                                            <a>1</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>)

}

export default SetupRef;